import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-encash-auth-form',
  templateUrl: './leave-encash-auth-form.component.html',
  styleUrls: ['./leave-encash-auth-form.component.css']
})
export class LeaveEncashAuthFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/leave-encash-authorization/leave-encash-auth-form/leave-encash-auth-form.component.ts